<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';
import TicketSelectorDropdown from 'dashboard/components/tickets/TicketSelectorDropdown.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const showTicketDropdown = ref(false);
const containerRef = ref(null);

const attachment = computed(() => {
  return attachments.value[0];
});

const url = computed(() => {
  return attachment.value?.dataUrl;
});

const fileName = computed(() => {
  if (url.value) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
  return t('CONVERSATION.UNKNOWN_FILE_TYPE');
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});

const toggleTicketDropdown = () => {
  showTicketDropdown.value = !showTicketDropdown.value;
};

const actions = computed(() => {
  const baseActions = [
    {
      href: url.value,
      label: t('CONVERSATION.DOWNLOAD'),
    },
  ];

  // Only show Add to Ticket action if attachment has an ID
  if (attachment.value?.id) {
    baseActions.unshift({
      onClick: toggleTicketDropdown,
      label: t('TICKETS.ATTACHMENTS.ADD_TO_TICKET'),
    });
  }

  return baseActions;
});
</script>

<template>
  <div ref="containerRef" class="relative">
    <BaseAttachmentBubble
      icon="i-teenyicons-user-circle-solid"
      icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
      sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
      :content="decodeURI(fileName)"
      :actions="actions"
    >
      <template #icon>
        <FileIcon :file-type="fileType" class="size-4" />
      </template>
    </BaseAttachmentBubble>
    <TicketSelectorDropdown
      v-if="attachment?.id"
      :attachment-id="attachment.id"
      :show="showTicketDropdown"
      :trigger-ref="containerRef"
      @close="showTicketDropdown = false"
      @linked="showTicketDropdown = false"
    />
  </div>
</template>
